export const OUTPUT_FORMATS = [
  { key: 'png', label: 'PNG', mime: 'image/png', extension: 'png' },
  { key: 'jpeg', label: 'JPG', mime: 'image/jpeg', extension: 'jpg' },
  { key: 'webp', label: 'WebP', mime: 'image/webp', extension: 'webp' },
]

export const convertImage = (image, formatKey) =>
  new Promise((resolve, reject) => {
    const format = OUTPUT_FORMATS.find((f) => f.key === formatKey)
    const canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    const ctx = canvas.getContext('2d')
    if (format.key !== 'png') {
      // JPG/WebP have no alpha channel — flatten onto white first so
      // transparent PNGs don't turn black.
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
    }
    ctx.drawImage(image, 0, 0)
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('Não foi possível converter essa imagem.'))
          return
        }
        resolve({ url: URL.createObjectURL(blob), size: blob.size, format })
      },
      format.mime,
      0.92,
    )
  })
